export const twoDigits = (num: number): string => {
  return num < 10 && num >= 0 ? '0' + num : num.toString();
};

export const addComma = (x: number): string => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const inArray = (array: any[], value: any): boolean => {
  return array.includes(value);
};
